import { Decimal, ZERO } from '@snap-types/types/decimal';

import {
  CalculateProductOptionPriceParams,
  CalculateProductOptionPriceResult,
} from './types';

export function calculateDefaultPriceAddition({
  option,
  quantity,
}: CalculateProductOptionPriceParams): CalculateProductOptionPriceResult {
  if (quantity.lte(ZERO)) {
    return {
      isSuccess: false,
      error: 'Quantity must be greater than 0',
      calculationMode: option.calculationMode,
    };
  }

  if (!option.price) {
    return {
      isSuccess: true,
      unitPriceAddition: new Decimal(ZERO),
      calculationMode: option.calculationMode,
    };
  }

  const unitPriceAddition = option.price.dividedBy(quantity);

  return {
    isSuccess: true,
    unitPriceAddition,
    calculationMode: option.calculationMode,
  };
}
